export default __webpack_public_path__ + "static/media/title-deco-bg.a5e07f15.webp";